import { render, staticRenderFns } from "./LeadLedger.vue?vue&type=template&id=e0513cf8"
import script from "./LeadLedger.vue?vue&type=script&lang=js"
export * from "./LeadLedger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports